import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'artemis-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit {

  @Input() size: 'small' | 'default' | 'big' | 'large' = 'default';

  constructor() { }

  ngOnInit() {
  }

  getSizeClass(): string {
    switch (this.size) {
      case 'small': {
        return 'size-sm';
      }

      case 'big': {
         return 'size-2x';
      }

      case 'large': {
        return 'size-3x';
      }

      default: {
        return '';
      }
    }
  }
}
